module.exports = __webpack_public_path__ + "static/media/translate_english.988c5596.svg";